import { Compass } from "lucide-react";
import { useNavigate } from "react-router";
import { Button } from "@/shared/ui/Button";

const ErrorPage = () => {
  const navigate = useNavigate();
  const handleRedirect = () => navigate("/");

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 py-12 text-center">
      <Compass
        size={68}
        className="text-blue-500 mb-6"
      />

      <h1 className="text-5xl font-extrabold text-gray-900 mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-700 mb-2">Page non trouvée</h2>
      <p className="text-gray-500 max-w-md mb-6">
        Désolé, la page que vous recherchez n'existe pas ou a pu être déplacée.
      </p>

      <Button
        onClick={handleRedirect}
        variant="action"
      >
        Retour au tableau de bord
      </Button>

      <div className="mt-12 text-sm text-gray-300">
        YeatiMini © - Onlyce ©
        {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default ErrorPage;
